/*
 * Copyright (C) 2025.  SimpliCity Digital Inc - All Rights Reserved
 */

import { createSlice } from "@reduxjs/toolkit";
import { websiteState } from "./website.state";

const websiteSlice = createSlice({
    name: "website",
    initialState: websiteState,
    reducers: {
        setWebsite (state, action) {
            state.webpage = action.payload;
        },
    }
});

export const websiteReducer = websiteSlice.reducer;

export const {
    setWebsite,
} = websiteSlice.actions;
